import { render } from "./allPage.vue?vue&type=template&id=378dddf4"
import script from "./allPage.vue?vue&type=script&lang=js"
export * from "./allPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__